/**
 * created by wang lei
 文字居右页面
 *
 */
import React, {Component} from 'react';
import alignTextRight from './alignTextRight.png'
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class AlignTextRightTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            btnChecked: false
        }
    }

    /**
     * 监听内容变化
     */
    listenContentChange(){
        let justify = this.props.editor.queryCommandValue("justify");
        this.setState({btnChecked: justify === 'right'});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let justify = this.props.editor.queryCommandValue("justify");
        this.setState({btnChecked: justify === 'right'});
    }

    render() {
        let style = {};
        if(this.state.btnChecked){
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return (
            <div className={"editor-justify-right-tool-btn"} style={{cursor:"pointer",...style}} onClick={()=>{
                this.props.editor.execCommand( 'justify', 'right' );
            }}>
                <img src={alignTextRight}/>
                <style>{`
                    .editor-justify-right-tool-btn{
                        border: 1px solid #f2f6fc;
                        line-height: 1.5;
                        height: 23px;
                        display: inline-block;
                    }
                    .editor-justify-right-tool-btn:hover{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                    }
                    .editor-justify-right-tool-btn:active{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                    }
                `}</style>
            </div>
        )
    }

}